import {
  GET_COURSES,
  GET_COURSE_ITEM,
  SET_COURSE_ITEM,
  UPDATE_COURSE_ITEM,
  ERROR_COURSE,
  SET_LOADING_COURSE,
  SEARCH_COURSES,
  SET_PRE_REQUISITE_LOADING,
  SET_LOADING_COURSE_IMAGE_FILE,
  SET_LOADING_COURSE_VIDEO_FILE,
  UPDATE_COURSE_IMAGE_FILE,
  UPDATE_COURSE_VIDEO_FILE,
  ERROR_COURSE_FILE_DATA,
} from "../types";

const initialState = {
  courses: null,
  searchCourse: null,
  courseItem: null,
  showImagePreview: true,
  showVideoPreview: true,
  isLoading: false,
  isLoadingImageFile: false,
  isLoadingVideoFile: false,
  error: null,
  errorFileData: null,
  preRequisiteLoading: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSES:
      return {
        ...state,
        courses: action.payload,
        isLoading: false,
      };

    case SEARCH_COURSES:
      return {
        ...state,
        searchCourse: action.payload,
        preRequisiteLoading: false,
      };

    case GET_COURSE_ITEM:
      return {
        ...state,
        courseItem: action.payload,
        showImagePreview: true,
        showVideoPreview: true,
        isLoading: false,
      };

    case SET_COURSE_ITEM:
      return {
        ...state,
        courseItem: action.payload,
        isLoading: false,
        error: null,
      };

    case UPDATE_COURSE_ITEM:
      return {
        ...state,
        courseItem: { ...state.courseItem, ...action.payload },
        isLoading: false,
        showImagePreview: true,
        showVideoPreview: true,
        isLoadingFileData: false,
        error: null,
      };

    case UPDATE_COURSE_IMAGE_FILE:
      return {
        ...state,
        showImagePreview: false,
        isLoadingImageFile: false,
        errorFileData: null,
      };

    case UPDATE_COURSE_VIDEO_FILE:
      return {
        ...state,
        showVideoPreview: false,
        isLoadingVideoFile: false,
        errorFileData: null,
      };

    case SET_LOADING_COURSE:
      return {
        ...state,
        isLoading: true,
      };

    case SET_PRE_REQUISITE_LOADING:
      return {
        ...state,
        preRequisiteLoading: true,
      };

    case SET_LOADING_COURSE_IMAGE_FILE:
      return {
        ...state,
        isLoadingImageFile: true,
      };

    case SET_LOADING_COURSE_VIDEO_FILE:
      return {
        ...state,
        isLoadingVideoFile: true,
      };

    case ERROR_COURSE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ERROR_COURSE_FILE_DATA:
      return {
        ...state,
        isLoadingImageFile: false,
        isLoadingVideoFile: false,
        errorFileData: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
